module.exports = __webpack_public_path__ + "img/plans.95f4261b.png";